import loadable from '@loadable/component';

var FooterRelevantLinks = loadable(function () {
  return import('../FooterRelevantLinks-ea8d7be8.js');
});

export { FooterRelevantLinks as default };
//# sourceMappingURL=index.js.map
